import { Component, Injector, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { BaseEntityComponent, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { Observable, of } from "rxjs";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { CanComponentDeactivate } from "src/app/core/can-deactivate-guard.service";
import { IrregularidadeEmpresaDTO, TipoIrregularidadeEmpresaDTO } from "src/app/model/irregularidade-empresa.model";
import { PermissaoService } from "src/app/shared/permissao.service";

import { mergeMap, map } from 'rxjs/operators';
import moment from "moment";
import { AcompanhamentoBatchService } from "../acompanhamento-batch.service";
import { ControleAgendamentoProcessoHonraBatch, LogExecucaoProcessoBatchHonraDTO } from "src/app/model/controle-agendamento-processo-batch.model";
import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from '@angular/core';

@Component({
    selector: 'app-acompanhamento-batch-detalhe',
    templateUrl: './acompanhamento-batch-detalhe.component.html',
    standalone: false
})
@Pipe({
    name: 'timeFormat',
    standalone: false
})

export class AcompanhamentoBatchDetalheComponent extends BaseEntityComponent<ControleAgendamentoProcessoHonraBatch> implements PipeTransform  {
  
  private permissaoEdicao: Boolean;
  public  id: number;
  public modoDetalhe: boolean = true;
  public controleAgendamentoProcessoHonraBatch: ControleAgendamentoProcessoHonraBatch;

  constructor(
      private modalService: BnModalMessageService,
      private permissaoService: PermissaoService,
      protected injector: Injector,
      public service: AcompanhamentoBatchService,
      private datePipe: DatePipe
       ) {
        super(service);
        this.config.rotaLista = "acompanhamento-batch/pesquisa";
        this.config.bloquearTelaAoRecuperarModelo = true;
        this.permissaoEdicao = false;
  }


  ngOnInit(){
      this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp => {
          this.permissaoEdicao = resp[ROLE_GESTOR_ENVIO];
      });
      this.route.params.subscribe(params => {
        this.service.buscarPorId(params['id']).subscribe(resp => {
            this.controleAgendamentoProcessoHonraBatch = resp;
            // console.log("print dentro: " + JSON.stringify(this.controleAgendamentoProcessoHonraBatch))
        });
    });
  }

  transform(value) {
    const horas = Math.floor(value / 3600);
    const minutos = Math.floor((value % 3600) / 60);
    const segundos = (value % 3600) % 60;
    let horasZero
    let minutosZero
    let segundosZero

    if (horas == 0) {
      horasZero = ''
    }
    else if (horas != 0) {
      horasZero = horas + ' h'
    }
    if (minutos == 0) {
      minutosZero = ''
    }
    else if (minutos != 0) {
      minutosZero = minutos + ' min'
    }
    if (segundos == 0) {
      segundosZero = ''
    }
    else if (segundos != 0) {
      segundosZero = segundos + ' seg'
    }
    if ((horas || minutos || segundos) != 0) {
      return `${horasZero} ${minutosZero} ${segundosZero} `;
    }
    else
      return `nulo`;
  }

  
  voltarParaLista() {
    this.router.navigate(['/acompanhamento-batch/pesquisa']);
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }


}
